require('./mortgageBonusesModal.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ constants
const {
    BONUSES_KEY,
    TAGGING_LABEL_EVENTS,
    BONUS_KEY_CSS
} = require('constants/mortgageInsuranceBonuses');

const classKey = 'mortgage-insurance-bonuses-modal';

class MortgageBonusesModal extends React.Component {

    getPoeditorKey(term) {
        const { bonusKey } = this.props;
        const poeditorContext = `${bonusKey}InsuranceBonusModal`;
        return `${poeditorContext}-${poeditorContext}_${term}`;
    }

    getListBenefits() {
        const { bonusKey } = this.props;

        if (bonusKey) {
            return [1,2,3,4].map((itemNumber) => (
                <div
                    key={`mortgage-insurance-bonuses-modal-${itemNumber}`}
                    className="col-xs-6 mortgage-insurance-bonuses-modal__benefit display-block"
                >
                    <i className={`${classKey}__icon ${classKey}__icon--${BONUS_KEY_CSS[bonusKey]}-item${itemNumber}`}></i>
                    <FormattedText
                        value={this.getPoeditorKey(`item${itemNumber}Title`)}
                        className="mortgage-insurance-bonuses-modal__benefit-title"
                    />
                    <span
                        className="mortgage-insurance-bonuses-modal__separator"
                    ></span>
                    <FormattedText value={this.getPoeditorKey(`item${itemNumber}Description`)} />
                </div>
            ));
        }
    }

    handlePrimaryButton(isRepsol, repsolUrl) {
        const { recordTaggingEvent } = this.props;
        if (isRepsol) {
            recordTaggingEvent(TAGGING_LABEL_EVENTS.REPSOL_BUTTON, true);
            window.open(repsolUrl, '_blank');
        }
    }

    render() {
        const {
            showModal,
            bonusKey,
            onCloseCallback,
        } = this.props;

        const isLifeInsurance = bonusKey === BONUSES_KEY.lifeInsurance;
        const isCardInsurance = bonusKey === BONUSES_KEY.cards;
        const isWealthInsurance = bonusKey === BONUSES_KEY.wealth;
        const isRepsol = bonusKey === BONUSES_KEY.energyAndGas;
        const buttonText = formatText(this.getPoeditorKey('modalButton'));
        const buttonPrimaryText = isRepsol && formatText(this.getPoeditorKey('modalPrimaryButton'));
        const repsolUrl = isRepsol && formatText(this.getPoeditorKey('modalButtonUrl'));
        const notRepsolClass = `${classKey}--is-not-repsol`;
        const modalClass = `${classKey} ${!isRepsol ? notRepsolClass : ''}`;

        const modalContent = (
            <div className='mortagage-insurance-bonuses-wrapper' >
                <section className="mortgage-insurance-bonuses-modal__title">
                    <h3>{formatText(this.getPoeditorKey('title'))}</h3>
                </section>
                <section className="mortgage-insurance-bonuses-modal__benefits-section">
                    <div className="mortgage-insurance-bonuses-modal__benefits-description">
                        <FormattedText value={this.getPoeditorKey('description')} />
                    </div>
                    <div className="mortgage-insurance-bonuses-modal__benefits-list" >
                        {this.getListBenefits()}
                    </div>
                    <div className="mortgage-insurance-bonuses-modal__note">
                        <OKMessage
                            type="informative"
                        >
                            <FormattedText value={this.getPoeditorKey('note')} />
                        </OKMessage>
                    </div>
                    {isLifeInsurance || isCardInsurance ||isWealthInsurance ?
                        <div className="mortgage-insurance-bonuses-modal__subscript">
                            <FormattedText value={this.getPoeditorKey('subscript')} />
                        </div> : null
                    }
                </section>
            </div>
        );

        return (
            <OKModal
                hideHeader
                overlayClassName={modalClass}
                content={modalContent}
                onCloseCallback={() => onCloseCallback()}
                footerType="navigation"
                isOpen={showModal}
                onPrimaryButtonClick={() => this.handlePrimaryButton(isRepsol, repsolUrl)}
                onSecondaryButtonClick={() => onCloseCallback(true)}
                primaryButtonText={buttonPrimaryText}
                secondaryButtonText={buttonText}
                size={'extra-large'}
                
            />
        );
    }
}

MortgageBonusesModal.propTypes = {
    bonusKey: PropTypes.string.isRequired,
    showModal: PropTypes.bool.isRequired,
    recordTaggingEvent: PropTypes.func.isRequired,
    onCloseCallback: PropTypes.func.isRequired,
};

module.exports = MortgageBonusesModal